import client from "@/api/client"
import { useMutation } from "react-query"

const useFileManager = () => {
  const { mutateAsync: uploadFile, isLoading: isUploading } = useMutation(
    "upload-file",
    (file: File) => {
      const formData = new FormData()
      formData.append(`files`, file)
      //Client API doesn't recognise upload route for now, use the shared
      //axios instance directly so auth + workspace headers are still sent
      return client.instance.post("/upload", formData).then(function (response) {
        return response?.data[0]
      })
    }
  )

  const { mutateAsync: deleteFile, isLoading: isDeleting } = useMutation(
    "delete-file",
    (fileId: number) => client.upload.deleteUploadFilesId(fileId)
  )

  const createOrUpdateFile = async ({
    initialFileId,
    fileId,
    newFile,
  }: {
    initialFileId?: number
    fileId?: number
    newFile?: File
  }) => {
    let imageId = fileId
    const hasDeletedIllustration = initialFileId && !fileId
    if (hasDeletedIllustration) {
      await deleteFile(initialFileId)
      imageId = undefined
    }

    if (newFile) {
      await uploadFile(newFile).then((data) => {
        imageId = data?.id
      })
    }

    return imageId
  }

  return {
    uploadFile,
    isUploading,
    deleteFile,
    isDeleting,
    createOrUpdateFile,
    isCreatingOrUploadingFile: isUploading || isDeleting,
  }
}

export default useFileManager
